import _ from 'lodash'
import values from 'src/values'

class Resize {
    constructor() {
        this.funcs = []
        this.funcsObj = {}

        //---------0 bind function
        this.process = this.process.bind(this)

        //---------0 resize Event
        window.addEventListener('resize', this.onResize)
    }

    onResize = () => {
        //---------0 Update data on values
        values.onResize()

        //---------0 Dispatch
        this.process()
    }

    removeListerner() {
        window.removeEventListener('resize', this.onResize)
    }

    /**
     * Process method of Resize
     */
    process() {
        _.each(this.funcsObj, (value, key) => {
            if (this.funcsObj[key]) this.funcsObj[key]()
        })
    }

    /**
     * Add function to RAF and start RAF if needed
     * @param func
     */
    add(func, key) {
        let keyExist = _.some(this.funcs, function(o) {
            return _.has(o, key)
        })

        if (keyExist) return

        this.funcsObj[key] = func
    }

    remove(func, key) {
        delete this.funcsObj[key]
    }
}
var resize = new Resize()
export default resize


// WEBPACK FOOTER //
// ./src/utils/resize.js